import { useController } from "react-hook-form";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function Textarea(props) {
  const {
    label,
    type,
    name,
    id,
    placeholder,
    addOnRight,
    control,
    rows,
    // onBlur
  } = props;

  const {
    field,
    formState: {  errors },
  } = useController({
    name,
    control,
  });

  return (
    <div>
      {label && (
        <label
          htmlFor={label}
          className="block text-sm font-light leading-6 text-gray-900 inline-flex items-center justify-center"
        >
          <span>{label}</span>
        </label>
      )}
      <div
        className={classNames(
          "mt-2",
          errors[name] && "relative rounded-md shadow-sm",
          addOnRight && "relative rounded-md shadow-sm"
        )}
      >
        <textarea
          rows={rows}
          type={type}
          onChange={field.onChange} // send value to hook form
          onBlur={field.onBlur} // notify when input is touched/blur
          value={field.value} // input value
          name={field.name} // send down the input name
          inputRef={field.ref}
          id={id}
          className={classNames(
            "block w-full rounded-md border-0 py-1.5",
            errors[name]
              ? "text-red-900 placeholder:text-red-300 ring-red-300 focus:ring-red-500"
              : "placeholder:text-gray-400 ring-gray-200 focus:ring-blue shadow-sm",
            "ring-1 ring-inset  focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
          )}
          placeholder={placeholder}
          {...props}
        />
      </div>
    </div>
  );
}
